import React, { Component, createRef } from 'react';
import { Card } from 'ui';
import DateFormat from 'constants/date_format';
import VideoThumbnail from 'components/VideoResponse/Grading/VideoThumbnail';
import { withZiggeo } from 'components/ui/ZiggeoVideo/ziggeoHelpers';
import PreviewModal from 'components/OnDemandPractice/Learner/PreviousAttempts/PreviewModal';
import PreserveFormatting from 'components/shared/PreserveFormatting';

const formatDate = date => moment(date).format(DateFormat.LONG_AT_TIME);

class Attempt extends Component {
  state = {
    modalVisible: false,
  };

  inputRef = createRef();

  openModal = () => {
    this.setState({
      modalVisible: true,
    });
  };

  closeModal = () => {
    this.setState({
      modalVisible: false,
    });
  };

  selectInput = e => {
    const { current: input } = this.inputRef;
    if (input) {
      input.select();
    }
  };

  render() {
    const { attempt, hasZiggeoForAllMedia, apiKey } = this.props;
    const { modalVisible } = this.state;

    const thumbnail = attempt.recording ? attempt.recording.thumbnail : null;

    const isSeismic = !!attempt.recording.seismicId;

    return (
      <tr className="LearnerOverview-completionsTableRow">
        <td className="DataTable-name LearnerOverview-completionsTableCell">
          {attempt.prompt}
        </td>
        <td className="LearnerOverview-completionsTableCell LearnerOverview-completionsDateTableCell">
          {formatDate(attempt.createdAt)}
        </td>
        <td className="DataTable-name LearnerOverview-completionsTableCell">
          {!thumbnail && !isSeismic && (
            <PreserveFormatting>{attempt.answer}</PreserveFormatting>
          )}
          {(thumbnail || isSeismic) && (
            <div>
              <Card>
                <Card.Content>
                  <div
                    className="PreviousAttempt-thumbnail"
                    onClick={this.openModal}
                    onKeyDown={e => e.key === 'Enter' && this.openModal()}
                    tabIndex="0"
                    role="button"
                  >
                    <VideoThumbnail
                      mediaThumbnailSrc={thumbnail}
                      questionType={attempt.scenarioType}
                      isSeismic={isSeismic}
                    />
                  </div>
                </Card.Content>
                <Card.Content>
                  <div className="mb-8 c-gray-darker fz-base">
                    {t(
                      'practice.on_demand_practice.overview.learner_page.share_link_text',
                    )}
                  </div>
                  <div className="d-f ai-c">
                    <input
                      className="NewInput NewInput--white f-1 f-sh-0"
                      onFocus={this.selectInput}
                      onClick={this.selectInput}
                      ref={this.inputRef}
                      value={attempt.recording.url}
                      readOnly
                    />
                  </div>
                </Card.Content>
              </Card>
              <PreviewModal
                attempt={attempt}
                caption={t(
                  'practice.on_demand_practice.overview.learner_page.share_link_text',
                )}
                show={modalVisible}
                prompt={attempt.prompt}
                handleDismiss={this.closeModal}
                hasZiggeoForAllMedia={hasZiggeoForAllMedia}
                ziggeoApiKey={apiKey}
              />
            </div>
          )}
        </td>
      </tr>
    );
  }
}

export default withZiggeo(Attempt);
